import axios from 'axios';
import { WebSearchCriteria } from '../dtos';
import { getApiV1Url } from '../utils/api';

export async function createWebSearchCriteria(webSearchCriteria: WebSearchCriteria): Promise<WebSearchCriteria> {
  const { data } = await axios.post<WebSearchCriteria>(`${getApiV1Url()}/search-criteria`, webSearchCriteria);

  return data;
}
